'use strict';

var jsxRuntime = require('react/jsx-runtime');

const MediumWon = ()=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("circle", {
                cx: "20",
                cy: "20",
                r: "16",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("circle", {
                cx: "20",
                cy: "20",
                r: "11",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M25 16L22.5091 24L20 16",
                stroke: "white",
                strokeWidth: "1.6",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M26 20.3L26.8 20.3L26.8 18.7L26 18.7L26 20.3ZM24 20.3L26 20.3L26 18.7L24 18.7L24 20.3Z",
                fill: "white"
            }),
            jsxRuntime.jsx("path", {
                d: "M15 16L17.5 24L20 16",
                stroke: "white",
                strokeWidth: "1.6",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M14 18.7H13.2V20.3H14V18.7ZM16 18.7H14V20.3H16V18.7Z",
                fill: "white"
            })
        ]
    });
};
const SmallWon = ()=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("circle", {
                cx: "16",
                cy: "16",
                r: "14",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M21 12L18.5091 20L16 12",
                stroke: "white",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M22 16.2L22.7 16.2L22.7 14.8L22 14.8L22 16.2ZM20 16.2L22 16.2L22 14.8L20 14.8L20 16.2Z",
                fill: "white"
            }),
            jsxRuntime.jsx("path", {
                d: "M11 12L13.5 20L16 12",
                stroke: "white",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M10 14.8H9.3V16.2H10V14.8ZM12 14.8H10V16.2H12V14.8Z",
                fill: "white"
            })
        ]
    });
};
const Won = ({ size })=>{
    if (size === 'small') {
        return jsxRuntime.jsx(SmallWon, {});
    }
    return jsxRuntime.jsx(MediumWon, {});
};

module.exports = Won;
